import React, { useEffect } from 'react';
import Immutable from 'immutable';
import { useDispatch, useSelector } from 'react-redux';

import { viewGetInfo } from '@uncinc/react-drupal-core';


const ViewFilterElement = (props) => {
  // This is just a pass-through element.
  return props.onRender(props);
};

const ViewFilters = ({ viewId, display, onFilterUpdate, onResetFilter, onRender }) => {
  const dispatch = useDispatch();
  const filters = useSelector((state) => state.getIn(['viewInfo', viewId, 'display', display, 'display_options', 'filters'], Immutable.Map()));

  useEffect(() => {
    if (filters.isEmpty()) {
      dispatch(viewGetInfo(viewId));
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, viewId]);

  const updateFilter = (field, value) => {
    onFilterUpdate(field, value);
  };

  const defaultRender = (props) => {
    console.log('!! Element not implemented', props);
    return null;
  };

  return (
    // eslint-disable-next-line react/jsx-no-useless-fragment
    <>
      {
        filters && filters.valueSeq()
          .filter((filter) => {
            return filter.get('exposed', false) === true;
          })
          .map((filter, i) => {
            return (
              <ViewFilterElement
                key={filter.get('field')}
                filter={filter}
                onChange={updateFilter}
                onReset={onResetFilter}
                onRender={onRender || defaultRender}
              />
            );
          })
      }
    </>
  );
};

export default ViewFilters;
